import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  getUserProfileReport,
  UserProfileReportParams,
} from "@/api/userProfile";
import { UserProfileQueryKeys } from "./userProfileQueryKeys";

// Opened on demand by an admin; no polling — the refresh button refetches.
export const useUserProfileReport = (params: UserProfileReportParams) =>
  useQuery({
    queryKey: [UserProfileQueryKeys.Report, params],
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => getUserProfileReport({ signal, params }),
  });
